/**
 * Exporo pages
 * 
 * Don't forget to link the title to the corresponding translation key under appNavigation.ExporoPages
 *
*/
export const exporoPagesEnum = {
  // EXPORO: { title: 'Cockpit', url: process.env.VUE_APP_EXPORO_COCKPIT_URL, icon:'pie_chart' },
  EMONEY: { title: 'Emoney', url: process.env.VUE_APP_BASE_URL, icon:'account_balance_wallet' },
  BAADER: { title: 'Baader', url: process.env.VUE_APP_EXPORO_BAADER_URL, icon:'account_balance_wallet' },
  TRADING: { title: 'Trading', url: process.env.VUE_APP_EXPORO_TRADE_URL, icon:'repeat' },
  // BLOCKCHAIN_WALLET: { title: 'Blockchain', url: process.env.VUE_APP_BLOCKCHAIN_WALLET_URL, icon:'account_tree' },
  // USER_SERVICE: { title: 'Profile', url: process.env.VUE_APP_EXPORO_USER_URL, icon:'assignment_ind' },
};

export default exporoPagesEnum;
